// Single source of truth for "what data does an AI assessment still want?"
// Used by BOTH the product-list Data badge and the product modal so the two can
// never disagree about whether a product is Ready or Incomplete.
//
// `weight` is the only hard gate (mirrors REQUIRED_FOR_ASSESSMENT in
// server/services/pcfInputs.js): emissions are per-kg factors × weight, so a
// guessed weight is the biggest error source. Materials / country of origin /
// packaging are advisory — they improve accuracy but the estimator has
// fallbacks — yet they still count as "missing data" for the Ready/Incomplete
// signal the user sees.
//
// Callers pass already-resolved booleans/values (the modal resolves them from
// its live form; the list resolves them from product columns + pcf_inputs) so
// this stays a pure rules function with no knowledge of either data shape.
export function computeAiDataReadiness({ weight, hasMaterials, hasOrigin, hasPackaging }) {
  const requiredMissing = [];
  if (!weight) requiredMissing.push("weight");

  const recommendedMissing = [];
  if (!hasMaterials) recommendedMissing.push("materials");
  if (!hasOrigin) recommendedMissing.push("country of origin");
  if (!hasPackaging) recommendedMissing.push("packaging");

  return {
    requiredMissing,
    recommendedMissing,
    // blocked: a required field is missing, so an AI assessment can't run yet.
    blocked: requiredMissing.length > 0,
    // ready: nothing at all is missing — the green "Ready" state.
    ready: requiredMissing.length === 0 && recommendedMissing.length === 0,
  };
}
